<mat-toolbar color="accent">Approve MOH Claim</mat-toolbar>

<div class="flex flex-col gap-4 p-4">
  <form class="flex flex-col gap-4" [formGroup]="form">
    <pt-iso-date-selector
      formControlName="paymentDate"
      placeholder="Payment Date"
      subscriptSizing="dynamic"
      [max]="today"
    />

    <div class="rounded-md border border-solid border-slate-300 py-4">
      <div class="mb-4 flex justify-between px-4">
        <span class="font-bold opacity-80">Claim Item</span>
        <span class="font-bold opacity-80">Amount Payable (incl. GST)</span>
      </div>

      @for (item of items$ | async; track item.serviceCode.uid) {
        <div
          class="flex items-center gap-4 rounded border-t border-solid border-slate-300 p-2 hover:bg-gray-50"
        >
          <mat-checkbox
            [checked]="item.approved"
            (change)="toggleApproval(item)"
          />

          <div class="flex-1">
            <span class="text-sm font-medium">
              {{ item.quantity }} x {{ item.serviceCode.description }}
            </span>
          </div>

          <mat-form-field subscriptSizing="dynamic" class="w-40">
            <span matTextPrefix>$&nbsp;</span>
            <input
              matInput
              type="number"
              placeholder="0.00"
              step="0.01"
              min="0"
              [disabled]="!item.approved"
              [value]="item.amountPayable"
              (input)="updateAmountPayable(item, $event)"
            />
          </mat-form-field>
        </div>
      }
    </div>

    <div class="flex flex-col gap-2 self-end">
      <div class="flex min-w-[180px] justify-between">
        Total Claimed:
        <strong class="opacity-70">
          {{ extendedData.amountClaimed | currency }}
        </strong>
      </div>
      <div class="flex min-w-[180px] justify-between">
        Total Payable:
        <strong class="opacity-70">
          {{ amountPayable$ | async | currency }}
        </strong>
      </div>
    </div>
  </form>

  <pt-buttons-container>
    <button mat-stroked-button mat-dialog-close>Close</button>
    <button mat-flat-button color="primary" (click)="submit()">
      Approve Claim
    </button>
  </pt-buttons-container>
</div>
